// External Dependencies
import styled from '@emotion/styled';
import { space } from '../constants';

// Component Definition
const Container = styled.div({
  margin: '0 auto',
  maxWidth: 1100,
  padding: `0 ${space.lg}px`,
  width: '100%',
});

export default Container;
